export default {
  panelIsVisible: window.innerWidth > 768,
  listIsVisible: false,
  mobileCardIsVisilbe: false,
}
